import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setVariantTableState } from "../../Actions/VariantTable.action";
import { translate } from "../../Services/translation";
import { Svg } from "../Svg";

/**
 * Trigger button to show accessories in variant table
 *
 * @param {ProductItem} variant
 * @param variantAccessoriesOpen
 * @param rowRef
 * @param tableRef
 * @returns {JSX.Element|null}
 * @constructor
 */
const AccessoriesTriggerButton = ({ variant, variantAccessoriesOpen, rowRef, tableRef }) => {
    if (!variant) {
        return null;
    }

    const dispatch = useDispatch();
    const isOpen = variantAccessoriesOpen !== null && variantAccessoriesOpen.id === variant.id;
    const { queryParams } = useSelector((state) => state.variantTable);

    useEffect(() => {
        if (!rowRef.current || !isOpen) {
            return;
        }

        let distanceTop = rowRef.current.distanceTop(tableRef.current);
        let totalDistance = distanceTop + rowRef.current.offsetHeight;
        window.__litium.variables.rowOffsetTop = totalDistance;
        tableRef.current.style.setProperty('--row-offset-top', `${totalDistance}px`);
    }, [rowRef.current, variantAccessoriesOpen]);

    const setOpenAccessoriesPanel = (id) => {
        const newParams = { ...queryParams };

        if (id === null || id?.length === 0) {
            delete newParams['showAccessories'];
        } else {
            newParams['showAccessories'] = id;
        }

        dispatch(setVariantTableState({
            accessoryOpen: id,
            queryParams: newParams
        }))
    }

    return (
        <div className="variant-table__accessories">
            <div className="variant-table__accessories-trigger-container">
                <button
                    className={'button button--outline-teal button--sm variant-table__accessories-trigger' + (isOpen ? ' open' : '')}
                    onClick={() => setOpenAccessoriesPanel(isOpen ? null : variant.id)}
                >
                    <span>{translate('nmas.product.table.header.accessories.open')}</span> <Svg icon="link" />
                </button>
            </div>
        </div>
    );
}

export default AccessoriesTriggerButton;